export const episodes = [
  {
    id: 31,
    title: "Ep 31: New Perspectives on Adoption",
    slug: "ep-31-new-perspectives",
    youtubeId: "YXi6p7wvD08",
    date: "2024-05-29",
    duration: "48 min",
    excerpt: "Exploring fresh perspectives and evolving conversations about adoption, family, and identity in modern times.",
    seoArticle: "This episode brings new voices and perspectives to the ongoing conversation about adoption. We explore how societal attitudes are shifting, what new research tells us about adoption outcomes, and how adoptees, birth parents, and adoptive families are navigating these changing landscapes. The discussion highlights emerging best practices and the importance of staying open to new understandings."
  },
  {
    id: 30,
    title: "Ep 30: Understanding Adoption Complexities",
    slug: "ep-30-adoption-complexities",
    youtubeId: "fH9gwJYmyXk",
    date: "2024-05-22",
    duration: "52 min",
    excerpt: "A deep dive into the complex layers of adoption experiences, relationships, and the ongoing journey of understanding.",
    seoArticle: "Adoption is rarely simple or straightforward. This episode examines the multiple layers of complexity inherent in adoption - from legal and ethical considerations to emotional and psychological impacts. Our guests share nuanced stories that resist easy categorization, helping listeners understand that adoption experiences exist on a spectrum and that embracing this complexity is essential for growth and healing."
  },
  {
    id: 29,
    title: "Ep 29: Voices of Change",
    slug: "ep-29-voices-of-change",
    youtubeId: "YXi6p7wvD08",
    date: "2024-05-15",
    duration: "46 min",
    excerpt: "Advocates and activists share how they're working to reform adoption practices and center the voices of those most affected.",
    seoArticle: "Change in the adoption world comes from those brave enough to speak truth to power. This episode features advocates and activists who are working to reform adoption practices, push for legislative changes, and ensure that adoptee voices are centered in conversations about adoption. They share their strategies, successes, setbacks, and vision for a more ethical and transparent adoption system."
  },
  {
    id: 28,
    title: "Ep 28: Building Bridges",
    slug: "ep-28-building-bridges",
    youtubeId: "Bi3B5G2L5RA",
    date: "2024-05-08",
    duration: "50 min",
    excerpt: "Stories of connection, reconciliation, and building bridges across the adoption constellation.",
    seoArticle: "Building and maintaining relationships across the adoption constellation requires intention, courage, and compassion. This episode features stories of successful bridge-building - between adoptees and birth families, between adoptive parents and birth parents, and between siblings separated by adoption. These stories offer hope and practical wisdom for those seeking to create and sustain meaningful connections."
  },
  {
    id: 27,
    title: "Ep 27: Continuing the Conversation",
    slug: "ep-27-continuing-conversation",
    youtubeId: "YXi6p7wvD08",
    date: "2024-05-01",
    duration: "45 min",
    excerpt: "Continuing important conversations about adoption, family, identity, and the courage to tell our stories.",
    seoArticle: "The conversation about adoption is ongoing and ever-evolving. This episode brings together multiple voices to continue exploring the themes that matter most - identity, belonging, truth, healing, and hope. We discuss why these conversations are essential, how they're changing over time, and what it means to create space for all adoption experiences to be heard and honored."
  },
  {
    id: 26,
    title: "Ep 26: Nicole's Story - Two Women, Different Eras",
    slug: "ep-26-nicoles-story",
    youtubeId: "H7J3tWuhgBU",
    date: "2024-04-24",
    duration: "55 min",
    excerpt: "Host Janet Munro and guest Nicole Haley compare their unplanned pregnancies nearly twenty years apart—and how the times they lived in shaped the choices they believed were possible.",
    seoArticle: "In this powerful episode, we explore the contrast between adoption in 1969 and single motherhood decades later. Nicole and Janet share their deeply personal stories of navigating unplanned pregnancies in different eras, revealing how societal expectations and available support systems shaped their decisions. This conversation illuminates the evolution of choices available to women facing similar circumstances across generations."
  },
  {
    id: 25,
    title: "Ep 25: What Makes a 'Proper' Family? (Sharon McRoberts)",
    slug: "ep-25-sharon-mcroberts",
    youtubeId: "YXi6p7wvD08",
    date: "2024-04-17",
    duration: "53 min",
    excerpt: "Sharon shares her remarkable journey through foster care, international adoption, kinship care, and biological motherhood—raising ten children across cultures.",
    seoArticle: "Sharon's story challenges the definition of a 'proper' family. Through her experiences with foster care, international adoption, kinship care, and biological motherhood, she has created a beautiful tapestry of love that transcends traditional boundaries. Her journey with ten children from diverse backgrounds demonstrates that family is built on love, commitment, and connection rather than biology or conventional structures."
  },
  {
    id: 24,
    title: "Ep 24: Permanently Placed (Matt Stafford)",
    slug: "ep-24-matt-stafford",
    youtubeId: "fH9gwJYmyXk",
    date: "2024-04-10",
    duration: "43 min",
    excerpt: "Matt Stafford grew up in foster care and was 'permanently placed' but never adopted. He discusses the difference between legal paperwork and true belonging.",
    seoArticle: "Matt's story highlights the complexities of the foster care system and the profound difference between legal placement and emotional belonging. Growing up 'permanently placed' but never officially adopted, Matt shares his unique perspective on what it means to find home and family. His journey reveals the gaps in the system and the importance of genuine connection beyond legal documentation."
  },
  {
    id: 23,
    title: "Ep 23: The Ties That Bind (Deanna Shrodes)",
    slug: "ep-23-deanna-shrodes",
    youtubeId: "Bi3B5G2L5RA",
    date: "2024-04-03",
    duration: "58 min",
    excerpt: "Deanna Shrodes explores the complex emotions and relationships that emerge when adoptees search for and connect with their biological families.",
    seoArticle: "In this deeply moving episode, Deanna Shrodes shares her experience navigating the intricate web of relationships that comes with reunion. She discusses the emotional complexity of honoring both adoptive and biological family ties, the grief and joy that coexist in reunion, and the ongoing journey of integration and identity formation."
  },
  {
    id: 22,
    title: "Ep 22: Finding My Voice (Lesli Johnson)",
    slug: "ep-22-lesli-johnson",
    youtubeId: "CQEi0W7jrNM",
    date: "2024-03-27",
    duration: "51 min",
    excerpt: "Lesli Johnson shares her journey from silence to advocacy, finding the courage to speak her truth about her adoption experience.",
    seoArticle: "Lesli's powerful narrative chronicles her transformation from silence to speaking out. For years, she felt unable to express her true feelings about her adoption experience. This episode captures her journey to finding her voice, advocating for change, and helping others feel empowered to share their own stories."
  },
  {
    id: 21,
    title: "Ep 21: The Search (Pam Hasegawa)",
    slug: "ep-21-pam-hasegawa",
    youtubeId: "bFe9BsZ1gNA",
    date: "2024-03-20",
    duration: "47 min",
    excerpt: "Pam Hasegawa recounts her decades-long search for her birth family and the unexpected discoveries that changed everything.",
    seoArticle: "Pam's search story is one of persistence, hope, and surprising revelations. After years of searching, the answers she found were not what she expected. This episode explores the emotional rollercoaster of the search process, the importance of support systems, and the courage it takes to pursue the truth about one's origins."
  },
  {
    id: 20,
    title: "Ep 20: Chosen - Examining the Narrative",
    slug: "ep-20-chosen-narrative",
    youtubeId: "U-AWKM_ChcA",
    date: "2024-03-13",
    duration: "44 min",
    excerpt: "A critical examination of the 'chosen child' narrative and its impact on adoptee identity and self-perception.",
    seoArticle: "This thought-provoking episode challenges the common adoption narrative of being 'chosen.' We explore how this well-intentioned language can impact adoptees' sense of self, create unrealistic expectations, and sometimes mask the losses inherent in adoption. The conversation offers a nuanced look at adoption language and its psychological implications."
  },
  {
    id: 19,
    title: "Ep 19: Sealed Records and Open Hearts",
    slug: "ep-19-sealed-records",
    youtubeId: "cCiBpqiO8xA",
    date: "2024-03-06",
    duration: "49 min",
    excerpt: "Exploring the impact of sealed adoption records on identity, medical history, and the fight for adoptee rights.",
    seoArticle: "This episode delves into the controversial topic of sealed adoption records and their profound impact on adoptees' lives. We discuss the historical context of sealed records, the medical and psychological implications, and the ongoing advocacy efforts to restore adoptees' rights to their own information. Stories of those affected by these policies illustrate the human cost of secrecy."
  },
  {
    id: 18,
    title: "Ep 18: Transracial Adoption - Navigating Identity",
    slug: "ep-18-transracial-adoption",
    youtubeId: "CgibRs4U6_4",
    date: "2024-02-28",
    duration: "56 min",
    excerpt: "A candid conversation about the unique challenges and experiences of transracial adoptees navigating identity and belonging.",
    seoArticle: "This essential episode addresses the complex realities of transracial adoption. Our guests share their experiences growing up in families of different racial or ethnic backgrounds, navigating questions of identity, dealing with racism, and finding ways to connect with their cultural heritage. The conversation highlights the importance of cultural competency in adoptive families."
  },
  {
    id: 17,
    title: "Ep 17: Sibling Connections",
    slug: "ep-17-sibling-connections",
    youtubeId: "Fk9rV5-Ppvc",
    date: "2024-02-21",
    duration: "42 min",
    excerpt: "Stories of separated siblings finding each other and building relationships across the years and miles.",
    seoArticle: "The bond between siblings separated by adoption is unique and powerful. This episode features stories of siblings who found each other after years or decades apart. They share the joy of reunion, the challenges of building relationships as adults, and the special connection that persists despite time and distance."
  },
  {
    id: 16,
    title: "Ep 16: The Adoptive Parent Perspective",
    slug: "ep-16-adoptive-parent-perspective",
    youtubeId: "U-AWKM_ChcA",
    date: "2024-02-14",
    duration: "50 min",
    excerpt: "Adoptive parents share their journeys, challenges, and lessons learned in supporting their children's complex identities.",
    seoArticle: "In this episode, we hear from adoptive parents who are committed to honoring their children's full stories. They discuss the challenges of navigating open adoption, supporting search and reunion, addressing difficult questions, and creating space for their children's grief and loss. Their insights offer valuable lessons for all adoptive families."
  },
  {
    id: 15,
    title: "Ep 15: Late Discovery Adoptees",
    slug: "ep-15-late-discovery-adoptees",
    youtubeId: "CgibRs4U6_4",
    date: "2024-02-07",
    duration: "53 min",
    excerpt: "The unique trauma and identity crisis experienced by those who discover their adoption later in life.",
    seoArticle: "Late discovery adoptees face a unique set of challenges when they learn about their adoption as teenagers or adults. This episode explores the profound identity crisis, trust issues, and grief that can result from late disclosure. Our guests share their experiences and discuss the importance of truth and transparency in adoption."
  },
  {
    id: 14,
    title: "Ep 14: Birth Father Stories",
    slug: "ep-14-birth-father-stories",
    youtubeId: "WUvKxUvO2Yg",
    date: "2024-01-31",
    duration: "45 min",
    excerpt: "Often overlooked in adoption conversations, birth fathers share their experiences, grief, and perspectives.",
    seoArticle: "Birth fathers are frequently left out of adoption narratives. This groundbreaking episode centers their voices and experiences. Our guests share their stories of loss, the circumstances that led to adoption, their ongoing grief, and their hopes for connection with their children. These powerful testimonies challenge stereotypes and broaden our understanding of the adoption constellation."
  },
  {
    id: 13,
    title: "Ep 13: Adoption and Mental Health",
    slug: "ep-13-adoption-mental-health",
    youtubeId: "9tdurZcofvs",
    date: "2024-01-24",
    duration: "52 min",
    excerpt: "Exploring the mental health impacts of adoption trauma and the importance of adoption-competent therapy.",
    seoArticle: "This critical episode addresses the mental health implications of adoption, including attachment issues, complex trauma, identity struggles, and the importance of finding adoption-competent therapists. Mental health professionals and adoptees share insights about healing, therapy approaches that work, and the growing recognition of adoption as a trauma-informed issue."
  },
  {
    id: 12,
    title: "Ep 12: The Primal Wound",
    slug: "ep-12-primal-wound",
    youtubeId: "WTvhlm1zuNo",
    date: "2024-01-17",
    duration: "48 min",
    excerpt: "Discussing Nancy Verrier's groundbreaking theory about the impact of separation from the birth mother.",
    seoArticle: "Nancy Verrier's concept of the 'primal wound' revolutionized understanding of adoption trauma. This episode explores this theory and its implications, featuring adoptees who recognize this wound in their own experiences. We discuss attachment, the impact of early separation, and what this understanding means for adoptive families and adoption practice."
  },
  {
    id: 11,
    title: "Ep 11: International Adoption - Cultural Loss",
    slug: "ep-11-international-adoption",
    youtubeId: "oFCoxsczoc0",
    date: "2024-01-10",
    duration: "54 min",
    excerpt: "International adoptees discuss the profound loss of culture, language, and connection to their countries of origin.",
    seoArticle: "International adoptees face unique challenges including cultural displacement, language loss, and disconnection from their countries of origin. This episode features powerful stories from those adopted internationally, discussing racism, identity formation, heritage trips, and the lifelong journey of reconciling multiple cultural identities."
  },
  {
    id: 10,
    title: "Ep 10: Reunion - Expectations vs Reality",
    slug: "ep-10-reunion-expectations",
    youtubeId: "lCJ4lqDgdSY",
    date: "2024-01-03",
    duration: "46 min",
    excerpt: "The complex reality of reunion often differs dramatically from expectations. Hear honest stories about the journey.",
    seoArticle: "Reunion is often imagined as a fairy tale ending, but the reality is far more complex. This episode features honest conversations about the challenges of reunion, including navigating different expectations, dealing with rejection, managing complex emotions, and building relationships across years of separation. These stories offer realistic perspectives for those considering or navigating reunion."
  },
  {
    id: 9,
    title: "Ep 9: Adoptee Anger - Breaking the Silence",
    slug: "ep-09-adoptee-anger",
    youtubeId: "lCJ4lqDgdSY",
    date: "2023-12-27",
    duration: "43 min",
    excerpt: "Adoptees are often expected to be grateful. This episode creates space for anger, grief, and the full range of adoption emotions.",
    seoArticle: "Society often expects adoptees to be grateful, but this expectation can silence legitimate feelings of anger, loss, and grief. This powerful episode gives voice to adoptee anger, exploring its sources and validity. Our guests discuss the pressure to be the 'grateful adoptee,' the importance of acknowledging difficult emotions, and the healing that comes from honest expression."
  },
  {
    id: 8,
    title: "Ep 8: The Adoption Industry",
    slug: "ep-08-adoption-industry",
    youtubeId: "z_1Y5bughxQ",
    date: "2023-12-20",
    duration: "57 min",
    excerpt: "A critical look at adoption as an industry, including ethical concerns, profit motives, and the need for reform.",
    seoArticle: "This eye-opening episode examines adoption as a multi-billion dollar industry. We discuss ethical concerns, the role of profit in adoption, coercion of birth parents, and the need for comprehensive reform. Advocates and those with personal experience share insights about how the current system prioritizes adults' desires over children's needs and what changes are necessary."
  },
  {
    id: 7,
    title: "Ep 7: Grief and Loss in Adoption",
    slug: "ep-07-grief-and-loss",
    youtubeId: "86F05KcZ-LI",
    date: "2023-12-13",
    duration: "49 min",
    excerpt: "Acknowledging that adoption begins with loss. Exploring grief for all members of the adoption constellation.",
    seoArticle: "Adoption is often portrayed only as a positive solution, but it begins with profound loss. This episode honors the grief experienced by adoptees, birth parents, and even adoptive parents. We discuss ambiguous loss, disenfranchised grief, and the importance of acknowledging and processing loss as part of the adoption experience."
  },
  {
    id: 6,
    title: "Ep 6: DNA Surprises",
    slug: "ep-06-dna-surprises",
    youtubeId: "yrgeSIbO-Zk",
    date: "2023-12-06",
    duration: "44 min",
    excerpt: "The explosion of DNA testing has led to unexpected discoveries. Hear stories of surprise connections and identity revelations.",
    seoArticle: "DNA testing has revolutionized the search process and led to countless unexpected discoveries. This episode features stories of surprising DNA connections, including unknown siblings, different parentage than expected, and connections that changed everything. We discuss the emotional impact of these discoveries and the ethics of DNA testing in adoption."
  },
  {
    id: 5,
    title: "Ep 5: Birth Mother Courage",
    slug: "ep-05-birth-mother-courage",
    youtubeId: "zfUrxc43Q6w",
    date: "2023-11-29",
    duration: "51 min",
    excerpt: "Birth mothers share their stories of impossible choices, enduring love, and the courage it takes to speak their truth.",
    seoArticle: "Birth mothers have historically been silenced and shamed. This episode centers their voices and honors their courage. Our guests share their experiences of making the most difficult decision of their lives, living with loss, and finding the strength to speak out. Their stories challenge stereotypes and reveal the enduring love that transcends separation."
  },
  {
    id: 4,
    title: "Ep 4: The Adoptee Experience",
    slug: "ep-04-adoptee-experience",
    youtubeId: "kPpXZiIUpII",
    date: "2023-11-22",
    duration: "47 min",
    excerpt: "Adoptees share their diverse experiences, challenging the single narrative often presented about adoption.",
    seoArticle: "There is no single adoptee experience. This episode features multiple adoptee voices sharing their unique journeys, perspectives, and feelings about adoption. From those who had positive experiences to those dealing with trauma, these stories illustrate the complexity and diversity of adoptee experiences and the importance of listening to all voices."
  },
  {
    id: 3,
    title: "Ep 3: Open Adoption - Promise and Reality",
    slug: "ep-03-open-adoption",
    youtubeId: "AFNbeBQZMwY",
    date: "2023-11-15",
    duration: "42 min",
    excerpt: "Exploring the promises and challenges of open adoption, and what happens when agreements aren't honored.",
    seoArticle: "Open adoption is often presented as the solution to adoption's challenges, but the reality can be complicated. This episode explores both successful open adoptions and situations where promised openness was closed. We discuss the importance of legally enforceable agreements, the impact on all parties when contact is lost, and best practices for maintaining healthy open adoption relationships."
  },
  {
    id: 2,
    title: "Ep 2: The Moment That Changed Everything",
    slug: "ep-02-moment-changed-everything",
    youtubeId: "s_OXR_ysvjw",
    date: "2023-11-08",
    duration: "24 min",
    excerpt: "What happens when you start asking questions about your past — and the answers surprise you?",
    seoArticle: "This episode follows powerful stories of faith, loss, and rediscovery. Our guests share the pivotal moments when they began questioning their adoption stories, what they discovered, and how those revelations changed their understanding of themselves and their families. These turning points often mark the beginning of a journey toward truth and healing."
  },
  {
    id: 1,
    title: "Ep 1: Janet's Story",
    slug: "ep-01-janets-story",
    youtubeId: "v3_1CAwXhCg",
    date: "2023-11-01",
    duration: "36 min",
    excerpt: "Janet shares her own journey as a birth mother, the decision that shaped her life, and the reunion that started it all.",
    seoArticle: "I don't know much about podcasting, what I do know is that there are millions of adoption stories that need to be told. In this inaugural episode, host Janet Munro shares her deeply personal story as a birth mother. She discusses the circumstances that led to her decision, the decades of silence and grief, and the reunion that transformed her life and inspired this podcast. Janet's story sets the foundation for honest, compassionate conversations about all aspects of the adoption experience."
  }
];